import { useQuery } from "react-query";
import { getCubaREST, WithId } from "@cuba-platform/react";
import { makeCollectionContainer } from "../../util";
import { FetchOptions } from "@cuba-platform/rest";

type UseDictionaryQueryOptions<T> = {
  /**
   * Название именованного запроса, например "myCustomQuery"
   */
  queryName: string;

  /**
   * Параметры запроса, передаваемые в .query()
   */
  params?: Record<string, any>;

  /**
   * Настройки запроса: view, limit и т.д.
   */
  fetchOptions?: FetchOptions;

  /**
   * Callback при загрузке
   */
  onLoaded?: (container: { items: T[]; status: "DONE" }) => void;

  /**
   * Включение запроса
   */
  enabled?: boolean;
};

export function useDictionaryQuery<T extends WithId>(
  entityName: string,
  options: UseDictionaryQueryOptions<T>,
) {
  const {
    queryName,
    params,
    fetchOptions = {},
    onLoaded,
    enabled = true,
  } = options;

  const fetchQuery = async (): Promise<{ items: T[]; status: "DONE" }> => {
    const response = await getCubaREST().query<T>(
      entityName,
      queryName,
      params,
      fetchOptions,
    );

    return makeCollectionContainer(response);
  };

  return useQuery({
    queryKey: ["dictionary-query", entityName, queryName, params, fetchOptions],
    queryFn: fetchQuery,
    staleTime: 1000 * 60 * 10,
    enabled,
    onSuccess: (container) => {
      if (onLoaded) {
        onLoaded(container);
      }
    },
  });
}
